import { defaultGrid } from "@helpers/datagrid";
import defaultReducer from "./defaultReducer";

const initialState = {
  ...defaultGrid,
  siteDisplay: "",
  machineDisplay: "",
};

export default defaultReducer("VARIANCE_HISTORY_DETAILS_MODAL", initialState);
